import React, {Component} from 'react'
import PropTypes from 'prop-types'
import FilterStatus from "./filters/FilterStatus"
import FilterDatePush from "./filters/FilterDatePush"
import FilterShippingCarrier from "./filters/FilterShippingCarrier"

class ListingJobFilter extends Component {
    render() {
        const {onChangeSelect, filters} = this.props

        return (
            <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                <div className="ListingJobFilter">
                    <div className='d-flex align-content-center'>
                        <FilterStatus status={filters.status} onChangeSelect={onChangeSelect}/>
                        <FilterDatePush onChangeSelect={onChangeSelect}/>
                        <FilterShippingCarrier shipping={filters.shipping_carrier} onChangeSelect={onChangeSelect}/>
                    </div>
                </div>
            </div>
        )
    }
}

ListingJobFilter.propTypes = {
    filters: PropTypes.object.isRequired,
    onChangeSelect: PropTypes.func.isRequired
}

export default ListingJobFilter